
class ScrollWipeSlider extends HTMLElement {
  constructor() {
    super();
    this.handleMutations = this.handleMutations.bind(this);
  }

  connectedCallback() {
    this.setup();
    this.observeChanges();
    this.addHoverListeners();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  setup() {
    this.slides = Array.from(this.querySelectorAll('.slide'));
    this.total = this.slides.length;
    if (!this.total) return;

    this.slides.forEach(slide => {
      slide.style.position = 'absolute';
      slide.style.inset = '0';
      slide.style.transition = 'clip-path 0.9s ease, transform 0.9s ease';
      slide.style.opacity = '1';
      slide.style.transform = 'scale(1)';
    });

    this.applyActiveState();
  }

  observeChanges() {
    this.observer = new MutationObserver(this.handleMutations);
    this.observer.observe(this, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  handleMutations(mutations) {
    let needsUpdate = false;

    mutations.forEach(mutation => {
      if (
        mutation.type === 'childList' ||
        (mutation.type === 'attributes' &&
          mutation.target.classList?.contains('slide'))
      ) {
        needsUpdate = true;
      }
    });

    if (needsUpdate) {
      requestAnimationFrame(() => this.setup());
    }
  }

  applyActiveState() {
    const activeSlides = this.slides.filter(slide =>
      slide.classList.contains('active')
    );
    if (!activeSlides.length) return;

    this.slides.forEach(slide => slide.style.zIndex = '1');

    const latest = activeSlides[activeSlides.length - 1];
    latest.style.zIndex = '10';

    latest.style.transition = 'none';
    latest.style.clipPath = 'inset(100% 0 0 0)';
    latest.style.transform = 'scale(1.05)';

    void latest.offsetWidth;

    latest.style.transition = 'clip-path 0.9s ease, transform 0.9s ease';
    latest.style.clipPath = 'inset(0 0 0 0)';
    latest.style.transform = 'scale(1)';

    activeSlides.slice(0, -1).forEach(slide => {
      slide.style.clipPath = 'inset(0 0 0 0)';
      slide.style.transform = 'scale(1)';
      slide.style.zIndex = '1';
    });
  }

  addHoverListeners() {
    this.slides.forEach((slide, index) => {

      slide.addEventListener('click', () => this.activateSlide(index));
    });
  }

  activateSlide(index) {
    this.slides.forEach(slide => slide.classList.remove('active'));
    const slide = this.slides[index];
    if (slide) slide.classList.add('active');
    this.applyActiveState();
  }
}

customElements.define('scroll-wipe-slider', ScrollWipeSlider);

